export default "__VITE_ASSET__31e55763__"